var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsBlockedActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 17.583 17.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "blocked-circle-svgrepo-com",
    d: "M8.792,17.583a8.792,8.792,0,1,1,8.792-8.792A8.792,8.792,0,0,1,8.792,17.583Zm0-1.465A7.326,7.326,0,1,0,1.465,8.792,7.326,7.326,0,0,0,8.792,16.118ZM11.937,4.61a.733.733,0,1,1,1.036,1.036L5.646,12.973A.733.733,0,1,1,4.61,11.937Z",
    transform: "translate(17.583) rotate(90)",
    fill: "#1450ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsBlockedActiveIcon);
export default __webpack_public_path__ + "static/media/settings-blocked-active-icon.5c5a035a7e33e8bcb678a9612955bb19.svg";
export { ForwardRef as ReactComponent };